export const name = 'builderModuleLoader' as const

export const ReactTemplateSymbol = Symbol('ReactTemplateSymbol')
export const ESMLoaderFactorySymbol = Symbol('ESMLoaderFactorySymbol')
export const PromiseCacheSymbol = Symbol('PromiseCacheSymbol')
export const ImportMapSymbol = Symbol('ImportMapSymbol')
